/* global Qualvu */
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { KeyCodes } from '../constants/appConstants'

const { TAB, LEFT, RIGHT, UP, DOWN } = KeyCodes

export default class TimestampInput extends Component {
  static propTypes = {
    max: PropTypes.number.isRequired, // in seconds
    onChange: PropTypes.func.isRequired,
    time: PropTypes.number.isRequired // in seconds
  }

  static defaultProps = {
    max: 0,
    time: 0
  }

  state = {
    selectionEnd: 0,
    selectionStart: 0
  }

  handleClick = () => {
    this.selectRangeAtCursorPosition(this.input.selectionStart)
  }

  handleKeyDown = e => {
    const { selectionStart } = this.input

    if (e.ctrlKey || e.metaKey || e.keyCode === TAB) {
      return
    }

    e.preventDefault()

    switch (e.keyCode) {
      case LEFT:
        this.selectRangeAtCursorPosition(selectionStart - 3)
        break
      case RIGHT:
        this.selectRangeAtCursorPosition(selectionStart + 3)
        break
      case UP:
        this.incrementTimeAtCursorPosition(selectionStart)
        break
      case DOWN:
        this.decrementTimeAtCursorPosition(selectionStart)
        break
    }
  }

  incrementTimeAtCursorPosition(cursorPosition) {
    const { max, onChange, time } = this.props
    const newTime = Math.min(
      max,
      time + this.secondsAtCursorPosition(cursorPosition)
    )

    if (newTime !== time) {
      onChange(newTime)
    }
  }

  decrementTimeAtCursorPosition(cursorPosition) {
    const { onChange, time } = this.props
    const newTime = Math.max(
      0,
      time - this.secondsAtCursorPosition(cursorPosition)
    )

    if (newTime !== time) {
      onChange(newTime)
    }
  }

  selectRangeAtCursorPosition(cursorPosition) {
    if (cursorPosition < 3) {
      this.selectRange(0, 2)
    } else if (cursorPosition < 6) {
      this.selectRange(3, 5)
    } else if (cursorPosition < 9) {
      this.selectRange(6, 8)
    } else {
      this.selectRange(9, 11)
    }
  }

  selectRange(selectionStart, selectionEnd) {
    this.setState({ selectionStart, selectionEnd })
  }

  secondsAtCursorPosition(cursorPosition) {
    if (cursorPosition < 3) {
      return 3600 // hours
    } else if (cursorPosition < 6) {
      return 60 // minutes
    } else if (cursorPosition < 9) {
      return 1 // seconds
    }

    return 0.01 // milliseconds
  }

  componentDidUpdate() {
    const { selectionStart, selectionEnd } = this.state

    this.input.setSelectionRange(selectionStart, selectionEnd)
  }

  render() {
    const { time } = this.props

    return (
      <input
        type="text"
        ref={input => {
          this.input = input
        }}
        value={Qualvu.Util.formatTimeFromSeconds(time)}
        onClick={this.handleClick}
        onKeyDown={this.handleKeyDown}
        readOnly
      />
    )
  }
}



// WEBPACK FOOTER //
// ../src/components/TimestampInput.js